"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../index");

var _index2 = require("../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _copysnippetfield_styles = _interopRequireDefault(require("./copysnippetfield_styles"));

var _copysnippetfield_definition = _interopRequireDefault(require("./copysnippetfield_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ COPY SNIPPET FIELD ~~~~~~~~~~ ========== */


var CopySnippetField = (0, _reactJss.default)(_copysnippetfield_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "copysnippetfield".concat((0, _index2.generateClasses)(props), " ").concat(props.classes.copysnippetfield)
  }, _react.default.createElement("div", {
    className: "codepiece"
  }, _react.default.createElement("h3", {
    className: 'title'
  }, props.title), _react.default.createElement("p", {
    className: 'description'
  }, props.description), _react.default.createElement(_index.Group, null, _react.default.createElement(_index.CopyField, {
    name: 'copyfield',
    defaultValue: props.codeSnippet,
    handleCopy: function handleCopy(fieldVal, e) {},
    height: 'inline',
    readyOnly: true,
    margin: '0px',
    fieldType: 'textfield',
    scrollbarColor: 'transparent',
    ctaVariant: 'primary',
    showLink: true,
    ctaPosition: 'block',
    link: props.link,
    handleLinkClick: props.handleLinkClick
  }))));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(CopySnippetField, _copysnippetfield_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = CopySnippetField;
exports.default = _default;